<template>
  <base-section id="committee">
    <v-container>
    <base-section-heading
    title="Organizing Committee"
    color="secondary"
    align="left"
    :toColor="true"
    >
    <v-row>
    <v-col
      cols="12"
      md="6"
    >
    <strong>General Co-Chairs<br /></strong>
    Leticia Bolzani Pöhls - RWTH Aachen, Germany<br />
    Yervant Zorian - Synopsys, USA<br />
    <br /><strong>Vice-General Chair<br /></strong>
    Tiago Balen - UFRGS, Brazil<br />
    <br /><strong>Past General Co-Chairs<br /></strong>
    Victor Champac - INAOE, Mexico<br />
    Yervant Zorian - Synopsys, USA<br />
    <br /><strong>Program Co-Chairs<br /></strong>
    Ernesto Sanchez - Politecnico di Torino, Italy<br />
    Marcelo Lubaszewski - UFRGS, Brazil<br />
    <br /><strong>Vice-Program Chair<br /></strong>
    Cristina Meinhardt - UFSC, Brazil<br />
    <br /><strong>Financial Chair<br /></strong>
    Paulo Butzen - UFRGS, Brazil<br />
    <br /><strong>Publication Co-Chairs<br /></strong>
    Jarbas Silveira - UFC, Brazil<br />
    Thiago S. Copetti - RWTH Aachen, Germany<br />
    <br /><strong>Embedded Tutorial Chair</strong><br />
    Matteo Sonza Reorda - Politecnico di Torino, Italy<br />
    </v-col>
    <v-col
      cols="12"
      md="6"
    >
    <br /><strong>Special Session Co-Chairs</strong><br />
    Florence Azais, LIRMM - France<br />
    Graziano Pravadeli - University of Verona, Italy<br />
    Fabian Luis Vargas - IHP, Germany<br />
    <br /><strong>Publicity Chair<br /></strong>
    Annachiara Ruospo - Politecnico di Torino, Italy<br />
    <br /><strong>Industry Relations Chair<br /></strong>
    Paolo Bernardi - Politecnico di Torino, Italy<br />
    <br /><strong>LA Liaison</strong><br />
    Victor Champac - INAOE, Mexico<br />
    <br /><strong>European Liaison<br /></strong>
    Hans-Joachim Wunderlich - University of Stuttgart, Germany<br />
    <br /><strong>USA Liaison<br /></strong>
    Abhijt Chatterjee - Georgia Tech, USA<br />
    <br /><strong>Web Chair<br /></strong>
    Giusy Iaria - Politecnico di Torino, Italy<br />
    <br /><strong>Symposium Local Support<br /></strong>
    Gustavo Platcheck<br />
    Clayton Farias<br />
    </v-col>
    </v-row>
    </base-section-heading>
    <base-section-heading
    title="Program Committee"
    color="secondary"
    align="left"
    :toColor="true"
    >
    <v-row>
      <v-col
        v-for="(program, i) in programs"
        :key="i"
        cols="12"
        md="6"
      >
        <base-section
          space="0"
          style="text-align: left"
        >
          {{ program.title }} - <i>{{ program.text }}</i>
        </base-section>
      </v-col>
    </v-row>
    </base-section-heading>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'Committee',

    data: () => ({

      programs: [
          {
          text: "Infineon Technologies AG",
          title: "Daniel Tille",
          },
          {
          text: "Politecnico di Torino",
          title: "Annachiara Ruospo",
          },
          {
          text: "University of California San Diego",
          title: "Alex Orailoglu",
          },
          {
          text: "RWTH",
          title: "Thiago Santos Copetti",
          },
          {
          text: "Sorbonne Université, CNRS, LIP6",
          title: "Haralampos-G. Stratigopoulos",
          },
          {
          text: "University of Applied Sciences Nordhausen",
          title: "Mario Schölzel",
          },
          {
          text: "Politecnico di Milano",
          title: "Antonio Miele",
          },
          {
          text: "University of Paderborn",
          title: "Sybille Hellbrand",
          },
          {
          text: "Testonica Lab",
          title: "Artur Jutman",
          },
          {
          text: "University of Athens",
          title: "Dimitris Gizopoulos",
          },
          {
          text: "UFRGS - Brazil",
          title: "Paulo F. Butzen",
          },
          {
          text: "Universidad Nacional de Colombia",
          title: "Felipe Restrepo-Calle",
          },
          {
          text: "Gunma University",
          title: "Haruo Kobayashi",
          },
          {
          text: "LIRMM",
          title: "Patrick Girard",
          },
          {
          text: "Politecnico di Torino",
          title: "Matteo Sonza Reorda",
          },
          {
          text: "Lyon Institute of Nanotechnology",
          title: "Alberto Bosio",
          },
          {
          text: "Auburn University",
          title: "Adit Singh",
          },
          {
          text: "Lund University",
          title: "Erik Larsson",
          },
          {
          text: "University of Stuttgart",
          title: "Ilia Polian",
          },
          {
          text: "Universität Bremen",
          title: "Rolf Drechsler",
          },
          {
          text: "Universidad de la Republica",
          title: "Julio Perez Acle",
          },
          {
          text: "Univ. Grenoble Alpes, CNRS, TIMA",
          title: "Rodrigo Possamai Bastos",
          },
          {
          text: "TIMA Laboratory",
          title: "Paolo Maistri",
          },
          {
          text: "Federal University of Paraíba",
          title: "Cleonilson Protasio",
          },
          {
          text: "Universidade Federal de ViÃ§osa",
          title: "José Augusto Nacif",
          },
          {
          text: "Semtech",
          title: "Hector Villacorta",
          },
          {
          text: "Tallinn University of Technology (TalTech)",
          title: "Samuel Pagliarini",
          },
          {
          text: "McMaster University",
          title: "Nicola Nicolici",
          },
          {
          text: "Politecnico di Torino",
          title: "Alessandro Savino",
          },
          {
          text: "TIMA",
          title: "Michele Portolan",
          },
          {
          text: "ONERA - The French Aerospace Lab",
          title: "Laurent Artola",
          },
          {
          text: "TIMA Laboratory",
          title: "Emmanuel Simeu",
          },
          {
          text: "University of Stuttgart",
          title: "Hans-Joachim Wunderlich",
          },
          {
          text: "Qualcomm Technologies Inc",
          title: "Soumya Mittal",
          },
          {
          text: "TIMA Laboratory",
          title: "Salvador Mir",
          },
          {
          text: "Politecnico di Torino",
          title: "Stefano Di Carlo",
          },
          {
          text: "Grenoble-INP/TIMA",
          title: "Regis Leveugle",
          },
          {
          text: "Synopsys",
          title: "Gurgen Harutyunyan",
          },
          {
          text: "Delft University of Technology",
          title: "Moritz Fieback",
          },
          {
          text: "University of Piraeus",
          title: "Mihalis Psarakis",
          },
          {
          text: "Politecnico di Torino",
          title: "Josie Esteban Rodriguez Condia",
          },
      ],

    }),
  }
</script>

<style>
.v-application .grey--text.text--darken-1 {
  color: black !important;
}
</style>
